import { ApiConfigBase } from "../api/ApiConfigBase";
import { ApiConfigCompany, BidNavVersion } from "../models/ApiConfigCompany";

class ApiConfig extends ApiConfigBase {
    getAvailableCompanies(): ApiConfigCompany[] {
        return [
            {
                "companyId": "UAL2",
                "displayName": "BidNav 2.0",
                "adminApiUrl": "https://admapi-fal.cclsoftware.com",
                "bidNavUrl": "https://my.bidnav.com",
                "bidNavApiUrl": "https://myapi.bidnav.com",
                "bnKey": "B3D60D229E64438CA490E49D21762E9B",
                "currency": "$",
                "currencyCode": "USD",
                "defaultCountryCode": "us",
                "bases": [],
                "aircraft": [],
                "positions": ["FO", "CA"],
                "useStaticData": false,
                "bidNavVersion": BidNavVersion.BidNav20
            },
            {
                "companyId": "UAL",
                "displayName": "United Legacy",
                "adminApiUrl": "https://admapi.cclsoftware.com",
                "bidNavUrl": "https://old.bidnav.com",
                "bidNavApiUrl": "https://old.bidnav.com",
                "bnKey": "B3D60D229E64438CA490E49D21762E9B",
                "currency": "$",
                "currencyCode": "USD",
                "defaultCountryCode": "us",
                "bases": ["CLE", "DCA", "DEN", "EWR", "GUM", "IAH", "LAS", "LAX", "MCO", "ORD", "SEA", "SFO"],
                "aircraft": ["320", "737", "756", "777", "787"],
                "positions": ["FO", "CA"],
                "useStaticData": true,
                "bidNavVersion": BidNavVersion.Legacy
            },
            {
                "companyId": "UAL IE",
                "displayName": "United IE",
                "adminApiUrl": "https://admapi-ie.cclsoftware.com",
                "bidNavUrl": "https://ie.bidnav.com",
                "bidNavApiUrl": "https://ie.bidnav.com",
                "bnKey": "B3D60D229E64438CA490E49D21762E9B",
                "currency": "$",
                "currencyCode": "USD",
                "defaultCountryCode": "us",
                "bases": ["XXX"],
                "aircraft": ["320", "737", "756", "777", "787"],
                "positions": ["EV", "IN"],
                "useStaticData": true,
                "bidNavVersion": BidNavVersion.IE
            },
            {
                "companyId": "BAL",
                "displayName": "British Airways",
                "adminApiUrl": "https://admapi-uk.cclsoftware.com",
                "bidNavUrl": "https://www.bidnav.uk",
                "bidNavApiUrl": "https://www.bidnav.uk",
                "bnKey": "B3D60D229E64438CA490E49D21762E9B",
                "currency": "£",
                "currencyCode": "GBP",
                "defaultCountryCode": "gb",
                "bases": ["LHR"],
                "aircraft": ["320", "737", "756", "777", "787"],
                "positions": ["FO", "CA"],
                "useStaticData": true,
                "bidNavVersion": BidNavVersion.UK
            }
        ];
    }
}

const Api_Config = new ApiConfig();
export default Api_Config;

